module.exports = __webpack_public_path__ + "cfabf0c2b781600308b887f56d4f18cd.eot";